import { Avatar, Box, Button, Grid, Paper, TextField } from "@mui/material";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useContext, useEffect, useState } from "react";
import { AuthenticationService, LoginForm } from "../../../services/authentication/AuthenticationService";
import { useNavigate } from "react-router";
import { AppContext } from "../../../contexts/AppContext";
import { ClientSocket } from "../../../services/ClientSocket";
import Layout from "../../Layout";



/**
 * Code inspired by the following tutorial:
 * https://www.youtube.com/watch?v=gimKHlOSN0g
 */




const Login = () => {
    const paperStyle = { padding: 20, margin: "0 auto" };
    const avatarStyle = { backgroundColor: '#1bbd7e' };
    const btnstyle = { margin: '8px 0' };

    const { jwtToken, setJwtToken, role, setRole, setSocket, setUserId, connectSocket, setReadConsent, setSurvey,setServer ,setStore} = useContext(AppContext);

    const navigateTo = useNavigate();

    useEffect(() => {
        if (jwtToken !== null) {
            console.log(`[Login] ========== LOGIN SUCCESS ==========`);
            console.log(`[Login] JWT Token:`, jwtToken);
            console.log(`[Login] User Role:`, role);
            console.log(`[Login] Navigating to:`, role === "ADMIN" ? "/admin" : "/game");
            
            if (role === "ADMIN")
                navigateTo("/admin");
            else
                navigateTo("/game");
        }
    }, [jwtToken]);


    // Username
    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");

    function handleEmailFocusLoss() {
        if (email.length === 0) { setEmailError("Vous devez spécifier un pseudonyme."); }
        else { setEmailError(""); }
    }

    // Password
    const [password, setPassword] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");

    function handlePasswordFocusLoss() {
        if (password.length === 0) { setPasswordError("Vous devez entrer un mot de passe."); }
        else { setPasswordError(""); }
    }

    function onForgetClick() {
        navigateTo("/forgetpassword");
    }

    function onLoginClick() {
        handleEmailFocusLoss();
        handlePasswordFocusLoss();

        if (
            password.length > 0 &&
            email.length > 0 &&
            passwordError.length === 0 &&
            emailError.length === 0
        ) {
            // REMOVE ME
            /*
            setRole("ADMIN");
            setJwtToken("SADFSAGOFDKGOFDS");
            */

            
            AuthenticationService.login(
                { email: email, password: password } as LoginForm,
                async (token: string, role: string, userId: string, hasReadConsent:boolean, survey:any,server:string, store:string) => {
                    try {
                        
                        setRole(role);
                        setJwtToken(token);
                        setUserId(userId);
                        setReadConsent(hasReadConsent)
                        setSurvey(survey)
                        setServer(server)
                        setStore(store)
                        
                        
                    } catch (error) {
                        console.error('[Login] Login process error:', error);
                        // Continue with navigation even if there are issues
                        // The user can still access the application
                    }
                }
            );
        }
    }


    return (
        <Layout>
            <Grid className="container-grande-marge">
                <Grid className="container-form">
                    <h2 className="serious-title" >Se connecter</h2>
                
                    <TextField
                        className="serious-input"
                        label='Courriel'
                        value={email}
                        error={emailError.length > 0}
                        helperText={emailError}
                        onChange={(e) => { setEmail(e.target.value); }}
                        onBlur={handleEmailFocusLoss}
                        fullWidth
                        sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                        InputLabelProps={{
                            shrink: true,
                        }} />
                    <Box className="container-btn-absolute">
                        <Button type='submit' onClick={onForgetClick} style={btnstyle} className="serious-txt-btn">Vous avez oublié votre mot de passe?</Button>
                        <TextField
                            className="serious-input"
                            label='Mot de passe'
                            type='password'
                            error={passwordError.length > 0}
                            helperText={passwordError}
                            value={password}
                            onChange={(e) => { setPassword(e.target.value); }}
                            onBlur={handlePasswordFocusLoss}
                            fullWidth
                            variant="outlined"
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                shrink: true,
                            }} />
                    </Box>
                    <Button type='submit' color='primary' variant="contained" onClick={onLoginClick} style={btnstyle} className="serious-btn">Se connecter</Button>
                </Grid>
            </Grid>
        </Layout>
    );
};


export default Login;